import {createSelector} from "@reduxjs/toolkit";
import {ITemplate} from "../../../types/interfaces";
import {IFilters} from "./TransactionsSlice";
import {RootState} from "../../store";

export const allTemplates = (state: RootState) => state.transactionsReducer.templates
export const transferDataPreview = (state: RootState) => state.transactionsReducer.transferDataPreview
export const getWithdrawalCode = (state: RootState) => state.transactionsReducer.withdrawalCode
export const selectFilters = (state: RootState) => state.transactionsReducer.filters
export const selectFiltersTemplates = (state: RootState) => state.transactionsReducer.filtersTemplates
export const allAccounts = (state: RootState) => state.userReducer.accountsList.accounts

export const selectTemplatesByFilter = createSelector<any, any>(
    allTemplates,
    selectFiltersTemplates,
    (allTemplates: ITemplate[], selectFilters: IFilters) => {

        let sortedTemplates = [...allTemplates]

        if (selectFilters.templateName === 'ALL') {
            sortedTemplates = allTemplates
        }

        if (selectFilters.recipient === '') {
            sortedTemplates = allTemplates
        }

        if (selectFilters.accountNumber !== 'ALL' && selectFilters.accountNumber !== '') {
            sortedTemplates = sortedTemplates.filter((template: ITemplate) => template.account === selectFilters.hiddenAccountNumber)
        }

        if (selectFilters.templateName && selectFilters.templateName !== 'ALL') {
            sortedTemplates = sortedTemplates.filter((template: ITemplate) => template.templateName === selectFilters.templateName)
        }

        if (selectFilters.recipient !== '') {

            sortedTemplates = sortedTemplates.filter((template: ITemplate) => {

                if (template.type === "Intra Transaction") {
                    return (
                        template?.toAccount?.toLowerCase() === selectFilters?.recipient?.toLowerCase()
                    )
                } else {

                    const valueForCompare = template.recipientDetails?.companyName
                        ? template.recipientDetails.companyName
                        : `${template.toAccountUserName
                            ? template.toAccountUserName
                            : (template.recipientDetails.beneficiaryName || `${template.recipientDetails.firstName} ${template.recipientDetails.lastName}`)}`


                    return (
                        valueForCompare.toLowerCase() === selectFilters?.recipient?.toLowerCase()
                    )
                }
            })
        }

        return sortedTemplates
    }
)

export const selectAccountsByFilter = createSelector<any, any>(
    allAccounts,
    selectFilters,
    (allAccounts: any, selectFilters: IFilters) => {

        let sortedAccounts = [...allAccounts]

        if (selectFilters.paymentRegion === 'SWIFT (International Transfer)') {
            sortedAccounts = allAccounts
        }

        if (selectFilters.paymentRegion === 'SEPA (only for EUR)') {
            sortedAccounts = sortedAccounts.filter((account: any) => account.currency === 'EUR')
        }

        return sortedAccounts.filter((account: any) => account.status === "Active")
    }
)

export const selectTopUpByAccount = createSelector<any, any>(
    allAccounts,
    selectFilters,
    (allAccounts: any, selectFilters: IFilters) => {

        let sortedAccounts = [...allAccounts.filter((account: any) => account.status === "Active")]

        const selectedAccount = sortedAccounts.find((account) => account.accountMainIban === selectFilters.accountNumber)

        return selectedAccount?.topUp
    }
)

export const selectTopUpInfo = createSelector<any, any>(
    allAccounts,
    selectFilters,
    (allAccounts: any, selectFilters: IFilters) => {

        let sortedAccounts = [...allAccounts.filter((account: any) => account.status === "Active")]

        const selectedAccount = sortedAccounts.find((account) => account.accountMainIban === selectFilters.accountNumber)

        if (selectFilters.paymentType === 'SEPA') {
            return selectedAccount.topUp.all.filter((topUpObj: any) => topUpObj.topUpType === 'sepa')
        }

        if (selectFilters.paymentType === 'international') {
            return selectedAccount.topUp.all.filter((topUpObj: any) => topUpObj.topUpType === 'international')
        }

    }
)

export const selectAccountForConfirmationLetter = createSelector<any, any>(
    allAccounts,
    selectFilters,
    (allAccounts: any, selectFilters: IFilters) => {

        let sortedAccounts = [...allAccounts.filter((account: any) => account.status === "Active")]

        const selectedAccount = sortedAccounts.find((account) => account.accountMainIban === selectFilters.accountNumber)

        return selectedAccount
    }
)
